import { defineComponent as _defineComponent } from 'vue'
import { Moment } from 'moment'
import { computed } from 'vue'
import {
  generateCalendarGridTemplateColumns,
  getDaysForPeriod,
} from '@/components/weekly-schedule/utils'

export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarGrid',
  props: {
    start: null,
    end: null,
    offsetLeft: null
  },
  setup(__props: any) {

const props = __props as {
  start: Moment
  end: Moment
  offsetLeft?:
    | `${number}px`
    | `var(--${string})`
    | `var(--${string}, ${number}px)`
}



const dayRange = computed(() => getDaysForPeriod(props.start, props.end))
const weekStart = computed(() => dayRange.value[0]?.name ?? 'sun')
const weekEnd = computed(
  () => dayRange.value[dayRange.value.length - 1]?.name ?? 'sat'
)

const gridStyle = computed(() => {
  return {
    '--week-start': `${weekStart.value}-start`,
    '--week-end': `${weekEnd.value}-end`,
    'grid-template-columns': generateCalendarGridTemplateColumns(
      dayRange.value,
      { offsetLeft: props.offsetLeft }
    ),
  }
})

return { __sfc: true,props, dayRange, weekStart, weekEnd, gridStyle }
}

})